import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  ViewRef,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {PATH, TOAST_TYPE} from "../../constants/Tpiq.constants";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {SwitchBoard} from "../../services/SwitchBoard";
import {DateFormater} from "../../services/DateFormatter.service";
import {LoadingService} from "../../services/LoadingService";
import {ToastService} from "../../services/Toast.service";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {FroalaViewModule} from "angular-froala-wysiwyg";
import {LinkyModule} from "ngx-linky";
import {NewCommentComponent} from "../comments/new-comment/new-comment.component";
import {CollaborationService} from "../../services/Collaboration.service";
import {CommentComponent} from "../comments/comment/comment.component";
import FroalaEditor from 'froala-editor';
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {ExportService} from "../../services/Export.service";
import { environment } from '../../../environments/environment';

declare let _: any;
declare let moment: any;
declare let jQuery: any;

@Component({
  selector: 'app-post-wall',
  standalone: true,
  imports: [CommonModule, FormsModule, FroalaViewModule, LinkyModule, FileUploadModule, NewCommentComponent, CommentComponent,FroalaEditorModule],
  templateUrl: './post-wall.component.html',
  styleUrls: ['./post-wall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostWallComponent implements OnInit, OnDestroy {
  @Input() post: any;
  @Input() taskId: any;
  @Input() pageType: string;
  @Input() channelType: string;
  @Input() companyId: string;
  @Input() isDocView: boolean;
  @Input() isDraftTaxPage: boolean;
  @Input() labelTypes: Array<any>;
  @Input() urgentlabelTypes: Array<any>;
  @Input() postStatus: Array<any>;
  @Input() displayType: string;
  @Input() org: string;
  @Input() hideComments: boolean;
  @Input() internalUsers: Array<any>;
  @Input() externalUsers: Array<any>;
  @Input() clientInternalUsers: Array<any>;
  @Input() teamUsers: Array<any>;
  @Input() taskSinglePost: boolean;
  @Input() collaborationAccess: boolean;
  @Input() secureUpload: boolean;
  @Input() sendSecure: boolean;
  @Output() onRemovePost: EventEmitter<string> = new EventEmitter<string>();
  @Output() onPatchDocument: EventEmitter<any> = new EventEmitter<any>();
  isBulkDocsMove: boolean;
  hasDocuments: boolean;

  popupDocument: any = {};
  editTaskWidth = '40%';
  uploader: any;
  uploadCount = 0;
  defaultSnapShots = ['default_2', 'default_3', 'default_4'];
  historyTask: any;
  displayComments = true;
  uploadingDocumentName: string;
  generatedId: string;
  editTask: any;
  folderPost: any;
  folderAttachemnt: any;
  type: string;
  user: any;
  updateObj: any = {};
  isQountOrg: boolean;
  isQountOrgUser = false;
  postUploadResp: any = [];
  reminderPeriods = [
    'In 20 mins',
    'In 1 hour',
    'In 3 hours',
    'Tomorrow',
    'Next Week'
  ];
  taskTypes = [
    'Reminder',
    'Task Reminder',
    'Block Party',
    'Progress Alert',
    'Task Update',
    'Task Creation',
    'Task Assignment',
    'Company creation',
    'Task Notes',
    'Invoice Payment',
    'London bells are ringing',
    'Payme',
    'Notify Mention',
    'Task Mention'
  ];
  reveal: any = {
    onMove: false,
    showHistory: false,
    uploadDocument: false,
    showDocument: false,
    movePost: false,
    workflowMapping: false,
    createPost: false,
    hop: false
  };
  showDocumentUploadDialog: boolean;
  uploadingDocumentNotes: string;
  labelDropdown = false;
  urgentlabelDropdown = false;
  statusDropdown = false;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  users: Array<any> = [];
  folderDoc: any;
  moveToCompanies: Array<any> = [];
  movePostModal: string;
  attachmentId = '';
  attachmentPost: any = {};
  mailToPost: any;

  showHandleDropdown = false;
  handleUsers: Array<any> = [];
  handleIds: Array<any> = [];
  selectedPostStatus: Array<any> = [];
  toggledGiphy = false;
  isGify = false;
  gifyUrl: any;
  @ViewChild('editPostEditor') private editPostEditor: ElementRef;
  editor: any;
  editorOptions = {
    heightMin: 50,
    autofocus: true,
    listAdvancedTypes: false,
    linkAlwaysBlank: true,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
    inlineMode: false,
    toolbarContainer: '#editorContainer',
    enter: FroalaEditor.ENTER_DIV,
    events: {

      initialized: (e) => {
        this.editor = e.getEditor();
        this.editor.events.on('image.beforePasteUpload', (img) => {
          const base64 = img.getAttribute('src');
          const arr = base64.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const exactMime = mime.split('/')[1];
          const imageName = 'image_' + Math.floor((Math.random() * 100) + 1) + '.' + exactMime;
          const base = this;
          this.urltoFile(base64, imageName, mime)
            .then((file: any) => {
              const files: any = [];

              files.push(file);
              base.uploader.addToQueue(files);
              base.startUpload(img, 'updatePost', base.updateObj.id);
            });
          this.editor.html.set('');
          return false;
        }, true);
      },
    },
    toolbarButtons: ['bold', 'italic', 'underline', 'color', 'formatOL', 'formatUL', 'quote', 'insertLink'],
    charCounterCount: false,
    quickInsertTags: [],
    toolbarSticky: false,
    toolbarBottom: true,
    placeholderText: 'Compose Message ...',
    zIndex: 1,
    theme: 'royal'
  };
  internalMails: Array<any> = [];
  externalMails: Array<any> = [];
  teamMails: Array<any> = [];
  imageLocation = 'https://static.taxplaniq.com/images/';
  allUsers: Array<any> = [];
  showMentionDropdown = false;
  mentionUsers: Array<any> = [];
  mentions: Array<any> = [];
  mentionIds: Array<any> = [];
  workflowMappings: Array<any> = [];
  userId: string;
  workflows: any;
  workflowBuckets: any;
  displayUserInfoWidget = false;

  bulckMoveDocsList: Array<any> = [];


  onEnter: string;
  searchCompanies: Array<any> = [];


  constructor(private switchBoard: SwitchBoard,
              private dateFormater: DateFormater,
              private changeDetectorRef: ChangeDetectorRef,
              private toastService: ToastService,
              private loadingService: LoadingService,
              private taxStrategyServices: ManageTaxStrategiesServices,
              private changeDetectionRef: ChangeDetectorRef,
              private collaborationService: CollaborationService,
              private reportService: ExportService,
            ) {}

  ngOnInit(): void {
    this._init();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (jQuery('#postCompanySearchInput-secureupload')) {
      jQuery('#postCompanySearchInput-secureupload').remove();
    }
  }

  _init() {
    const base = this;
    this.user = Session.getUser();
    // this.users = Session.getUsers();
    this.userId = Session.getUser().id;
     this.user = Session.getUser();
    this.isQountOrgUser = !this.user.isCustomer;
    this.uploaderUpdate();
    this.buildItemForm();
    this.updateSnapShots(this.post);
    this.uploader.onCompleteItem = (item, response, status, header) => {
      if (status === 200) {
        this.uploadCount++;
        this.postUploadResp.push(JSON.parse(response));
        this.uploader.progress = 100;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
          this.resetUploader();
          this.setUploadDocuments(JSON.parse(response));
          base.updateDocumentToPost(base.generatedId, JSON.parse(response));
          if (!(this.changeDetectionRef as ViewRef).destroyed) {
            this.changeDetectionRef.detectChanges();
          }
        } else {
          this.toastService.pop(
            TOAST_TYPE.success,
            this.uploadCount +
            '/' +
            this.uploader.queue.length +
            ' Uploaded Successfully'
          );
          this.setUploadDocuments(JSON.parse(response));
          this.loadingService.triggerLoadingEvent(false);
        }
      } else {
        this.toastService.pop(TOAST_TYPE.error, 'Error While Uploading');
        this.uploadCount++;
        if (this.uploader.queue.length === this.uploadCount) {
          this.loadingService.triggerLoadingEvent(false);
          this.uploadCount = 0;
        }
      }
    };

    this.switchBoard.onToastConfirm
      .pipe(takeUntil(this.destroy$))
      .subscribe(toast => {
        if (toast.data && toast.data.id == this.post.id) {
           this.deleteAttachment(this.attachmentId, this.attachmentPost);
        }
      });
  }

  deleteAttachment(attachmentId, obj?) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.removeDocument(this.user.id, this.org, attachmentId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (obj) {
          _.remove(obj.documents, {id: attachmentId});
        } else {
          _.remove(this.postUploadResp, {id: attachmentId});
          if (this.postUploadResp.length === 0) {
            this.resetUploader();
          }
        }

        this.toastService.pop(TOAST_TYPE.success, 'Document deleted successfully');
        this.updatePostData(obj);
        this.changeDetectionRef.detectChanges();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to delete document');
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete document');
        }
      });

  }

  setUploadDocuments(response) {
    this.post.documents = [...this.post.documents, {
      id: response.id,
      name: response.name,
      temporaryURL: response.temporaryURL,
      doc_notes: response.documentNotes ? response.documentNotes.documentNotes : ''
    }];
  }

  updateDocumentToPost(postId, document) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.collaborationService.updatePost(this.org, this.user.id, postId, this.post).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.success, "Document uploaded successfully");
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, "Failed to attach document");
    });
  }

  updateSnapShots(post) {
    const base = this;
    post.tooltipDate = base.updateDateTimeStamp(post.createdDate);
    post.displayDate = base.updateDateTimeStampForTooltip(post.createdDate);
    post.displayLine = false;
    post.isBotMessage = true;
    post.showReminder = false;

    post.documents = post.documents ? post.documents : [];

    post.comments = post.comments ? post.comments : [];
    _.each(post.documents, function(attachment) {
      const splitArray = attachment.name.split('.');
      if (
        base.isImage(splitArray[splitArray.length - 1]) &&
        attachment.temporaryURL
      ) {
        attachment.imageType = true;
        attachment.displayImage = true;
      }
    });
    return post;
  }

  isImage(extension) {
    const imageTypes = ['png', 'jpg', 'jpeg', 'bmp'];
    if (imageTypes.indexOf(extension.toLowerCase()) != -1) {
      return true;
    } else {
      return false;
    }
  }

  updateDateTimeStamp(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }

  updateDateTimeStampForTooltip(date) {
    const serviceFormat = 'YYYY-MM-DD HH:mm:ss';
    const dateFormat = 'Do MMM, YYYY HH:mm';
    const startTime = moment.utc(date).toDate();
    return this.dateFormater.formatDate(startTime, serviceFormat, dateFormat);
  }
  

  displayInfo() {
    setTimeout(() => {
      this.displayUserInfoWidget = true;
      this.changeDetectorRef.detectChanges();
    });
  }

  closeDisplayInfo() {
    this.displayUserInfoWidget = false;
    this.invokeChangeDetection();
  }

  invokeChangeDetection() {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  downloadDocument(attachment, type) {
    if (attachment.id) {
      this.loadingService.triggerLoadingEvent(true);
      this.taxStrategyServices.downloadDocument(Session.getUser().id, this.org, attachment.id)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          if (type === 'download') {
            window.open(response.temporaryURL);
          } else {
            window.open(response.viewDocContentURL);
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          const errorMessage = 'Failed to download document';
          this.toastService.pop(TOAST_TYPE.error, errorMessage);
        });
    }

  }

  openImage(attachment) {
    // this.reveal = {...this.reveal, showDocument: true};
    // this.popupDocument = {...attachment, selectedImage: `https://documents.taxplaniq.com/${attachment.id}`};
    // this.changeDetectionRef.detectChanges();
  }

  removeAttachment(attachmentId, obj?) {
    this.attachmentId = attachmentId ? attachmentId : '';
    this.attachmentPost = obj ? obj : {};
    const data = {
      id: obj.id
    };
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', data);
  }

  startUpload($event, type, id?: string) {
    const base = this;
    if (id) {
      this.generatedId = id;
    } else {
      this.generatedId = this.guid();
    }

    if (this.uploader.queue.length > 1) {
      setTimeout(() => {
        base.uploader.uploadAll();
      }, 400);
    } else {
      this.uploader.queue.forEach(function(item) {
        base.uploadingDocumentName = item.file.name;
      });

      // this.reveal = {...this.reveal, documentUpload: true};
      this.uploadDocument();
      this.changeDetectorRef.detectChanges();
    }
  }

  guid() {
    return (
      this.s4() +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      '-' +
      this.s4() +
      this.s4() +
      this.s4()
    );
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  uploadDocument() {
    const base = this;
    this.uploader.queue.forEach(function(item) {
      item.file.name = base.uploadingDocumentName;
    });
    this.uploader.uploadAll();
    this.loadingService.triggerLoadingEvent(true);
    this.updateObj = {};
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  uploaderUpdate() {
    const docUrl = this.taxStrategyServices.getVideoDocumentServiceUrl(this.org, Session.getUser().id);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [
        {
          name: 'Authorization',
          value: 'Bearer ' + Session.getToken()
        }
      ]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
  }

  buildItemForm() {
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.generatedId;
      payload.sourceType = 'TODO_POST';
      form.append('payload', JSON.stringify(payload));
    };
    this.postUploadResp = [];
  }

   hidePostOptions() {
    jQuery('.post_options')
      .siblings()
      .hide();
  }

  openComments() {
    this.hideComments = !this.hideComments;
  }

  handleCommentAction(commentId) {
    const index = _.findIndex(this.post.comments, {id: commentId});
    this.post.comments.splice(index, 1);
    this.refreshPost();
    this.invokeTimeago();
  }

  refreshPost() {
    try {
      this.changeDetectionRef.detectChanges();
      if (this.channelType === 'orgs') {
        console.log('change detection comments length', this.post.comments.length);
      }
    } catch (e) {
      console.log('error while refreshPost', e);
    }
  }

  invokeTimeago() {
    setTimeout(() => {
      jQuery('.post_options').on('mouseover', function($event) {
        jQuery(this)
          .siblings()
          .css('display', 'inline');
      });
      jQuery('.other-option').on('mouseover', function($event) {
        jQuery('.reminder-menu-list').hide();
      });
      jQuery('.remind-me-option').on('mouseover', function($event) {
        jQuery(this)
          .siblings()
          .css('display', 'inline');
      });
    }, 100);
  }

  resetUploader() {
    this.uploader.queue = [];
  }

    handlePostAction(action) {
    if (action === 'delete') {
      this.deletePost(this.post.id, this.post);
    } else if (action === 'read') {
      this.markPostRead();
    } else if (action === 'unread') {
      this.markPostUnread();
    } else if (action === 'move') {
      this.handleMovePost();
    } else if (action === 'download') {
      // this.downloadPost();
      this.exportToPDF();
    } else if (action === 'star') {
      this.addStar();
    } else if (action === 'unstar') {
      this.removeStar();
    } else {
      this.updatePost();
    }
  }

    deletePost(id, post) {
    this.collaborationService
      .deletePost(this.org, post).pipe(
      takeUntil(this.destroy$))
      .subscribe(
        response => {
          this.toastService.pop(TOAST_TYPE.success, 'Post Deleted Successfully');
          this.onRemovePost.emit(id);
          this.invokeTimeago();
        },
        error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete post');
        }
      );
  }

  updatePost() {
    const base = this;
    this.updateObj = {...this.post};
    if (this.post.mentionIds && this.post.mentionIds.length > 0) {
      _.forEach(this.post.mentionIds, function(mention) {
        const user = _.find(base.users, {id: mention});
        base.mentionIds = [...base.mentionIds, user];
        base.mentions = _.map(base.mentionIds, 'name');
      });
    }
    // this.gifyEdit();
    this.updateObj.internal_users = [];
    this.updateObj.external_users = [];
    if (this.channelType !== 'teams' && this.channelType !== 'orgs' && this.isQountOrgUser) {
      _.forEach(this.updateObj.internal_users, function(user) {
        base.internalMails.push(_.find(base.internalUsers, {id: user}));
      });

      _.forEach(this.updateObj.external_users, function(user) {
        base.externalMails.push(_.find(base.externalUsers, {id: user}));
      });
    }

    if (this.channelType == 'teams') {
      _.forEach(this.updateObj.internal_users, function(user) {
        base.teamMails.push(_.find(base.teamUsers, {id: user}));
      });
    }
    // this.reveal['updatePost'] = true;

  }

  markPostRead() {
    this.collaborationService
      .markPostRead(this.companyId, this.post.id).pipe(
      takeUntil(this.destroy$))
      .subscribe(
        response => {
          const index = this.post.tags.indexOf('Unread');
          this.post.tags = this.post.tags ? this.post.tags.filter((_, i) => i !== index) : [];
          this.changeDetectionRef.detectChanges();
          this.toastService.pop(TOAST_TYPE.success, 'Marked as Read');
          this.broadcastPostAction('read');
          this.qmailPostAction('read');
        },
        error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to Mark as Read');
        }
      );
  }

  markPostUnread() {
    this.collaborationService
      .markPostUnread(this.companyId, this.post.id).pipe(
      takeUntil(this.destroy$))
      .subscribe(
        response => {
          const index = this.post.tags.indexOf('Unread');
          if (index == -1) {
            this.post.tags = [...this.post.tags, 'Unread'];
          }
          this.changeDetectionRef.detectChanges();
          this.toastService.pop(TOAST_TYPE.success, 'Marked as Unread');
          this.broadcastPostAction('unread');
          this.qmailPostAction('unread');
        },
        error => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to Mark as Unread');
        }
      );
  }

  addStar() {
    if (this.post && !this.post.starred) {
      this.post.starred = true;
      if (this.channelType === 'teams') {
        this.markTeamPostStar(this.post);
      } else {
        this.markCompanyPostStar(this.post);
      }
    }
  }

  removeStar() {
    if (this.post && this.post.starred) {
      this.post.starred = false;
      if (this.post.channel_type === 'teams') {
        this.markTeamPostStar(this.post);
      } else {
        this.markCompanyPostStar(this.post);
      }
    }
  }

  markCompanyPostStar(post) {
    const base = this;
    this.collaborationService.markCompanyStarred(base.post.id, base.companyId).pipe(
      takeUntil(this.destroy$))
      .subscribe(response => {
          if (base.post.starred) {
            this.toastService.pop(TOAST_TYPE.success, 'Post Starred');
          } else {
            this.toastService.pop(TOAST_TYPE.success, 'Post Unstarred');
          }
          this.invokeChangeDetection();
        },
        error => {
          this.handleError(error);
          if (base.post.starred) {
            base.post.starred = false;
          } else {
            base.post.starred = true;
          }
        });
  }

  markTeamPostStar(post) {
    const base = this;
    this.collaborationService.markTeamStarred(base.post.id, base.companyId).pipe(
      takeUntil(this.destroy$))
      .subscribe(response => {
          if (base.post.starred) {
            this.toastService.pop(TOAST_TYPE.success, 'Post Starred');
          } else {
            this.toastService.pop(TOAST_TYPE.success, 'Post Unstarred');
          }
          this.invokeChangeDetection();
        },
        error => {
          this.handleError(error);
          if (base.post.starred) {
            base.post.starred = false;
          } else {
            base.post.starred = true;
          }
        });
  }

  handleMovePost() {
    this.loadingService.triggerLoadingEvent(true);
    this.collaborationService.getMoveToCompanies(this.channelType, this.companyId)
      .subscribe(companies => {
        this.loadingService.triggerLoadingEvent(false);
        this.moveToCompanies = [...companies];
        this.reveal.movePost = true;
        if (!(this.changeDetectionRef as ViewRef).destroyed) {
          this.changeDetectionRef.detectChanges();
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  

    exportToPDF() {
    const pdfReq = this.getPDFRequestObject();
    this.loadingService.triggerLoadingEvent(true);
    const url = PATH.PDF_SERVICE;
    this.reportService.exportReportIntoFile(url, pdfReq)
      .subscribe(data => {
        this.loadingService.triggerLoadingEvent(false);
        const blob = new Blob([data], {type: 'application/pdf'});
        const link = jQuery('<a></a>');
        link[0].href = URL.createObjectURL(blob);
        link[0].download = 'Post ' + moment(new Date()).format('MMMM DD, YYYY HH:mm a') + '.pdf';
        link[0].click();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Export Report Into PDF');
      });
  }

  updatePostData(post) {
    if(post && post.id) {
      const base = this;
      this.loadingService.triggerLoadingEvent(true);
      this.collaborationService.updatePost(this.org, this.user.id, post.id, post).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, "Failed to attach document");
      });

    }
  }

  urltoFile(url, filename, mimeType) {
    return (fetch(url)
        .then(function(res) {
          return res.arrayBuffer();
        })
        .then(function(buf) {
          return new File([buf], filename, {type: mimeType});
        })
    );
  }

  broadcastPostAction(action) {
    this.switchBoard.onPostAction.next({
      action,
      post: this.post,
      channel: Session.getConversation()
    });
  }

  qmailPostAction(action, data?) {
    const obj: any = {
      action,
      post: this.post,
    };
    if (action == 'remove-label') {
      obj.removedLabel = data;
    }
    if (action == 'handle' || action == 'unHandle') {
      obj.handle_user = data;
    }
    this.switchBoard.onqmailAction.next(obj);
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    error = error ? JSON.parse(error) : '';
    const message = error.message ? error.message : `Failed To perform operation`;
    try {
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (e) {
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

    getPDFRequestObject() {
    this.loadingService.triggerLoadingEvent(true);
    let html = jQuery('<div>').append(jQuery('#post_pdf' + this.post.id).clone()).html();
    html = html.replace(/(<img("[^"]*"|[^\/">])*)>/gi, '$1/>');
    html = html.replace(/<br>/g, '<br></br>');
    const pdfReq = {
      version: '1.1',
      genericReport: {
        payload: html,
        footer: moment(new Date()).format('MMMM DD, YYYY HH:mm a')
      }
    };
    return pdfReq;
  }

  onUpdateEnter($event, type) {
    $event && $event.preventDefault();
    const base = this;
    if (this.postUploadResp.length > 0) {
      this.updateObj = {...this.updateObj, documents: []};
      for (const i in this.postUploadResp) {
        const obj = {
          name: this.postUploadResp[i].name,
          id: this.postUploadResp[i].id,
          doc_notes: this.postUploadResp[i].documentNotes
            ? this.postUploadResp[i].documentNotes
            : ''
        };
        this.updateObj.documents = {...this.updateObj.documents, obj};
      }
    }
    if (!this.updateObj.html_message) {
      this.updateObj.html_message = this.updateObj.message;
    }
    // this.updateObj.gifLink = this.gifyUrl;
    this.updateObj.message = this.editPostEditor.nativeElement.innerText;
    this.prependMentions(this.updateObj);
    this.updateAccessUsers();
    this.resetFields();
    this.collaborationService
      .updateComment(this.org, this.channelType, this.updateObj, type, this.companyId).pipe(
      takeUntil(this.destroy$))
      .subscribe(
        response => {
          let responsobj = {...this.updateObj};
          responsobj = {
            ...responsobj, tooltipDate: base.updateDateTimeStamp(
              responsobj.createdDate
            ), displayDate: base.updateDateTimeStampForTooltip(
              responsobj.createdDate
            ), isBotMessage: false,
            comments: responsobj.comments ? [...responsobj.comments] : []
          };
          this.updateObj = {};
          this.updateSnapShots(responsobj);
          this.post = {...responsobj};
          this.changeDetectionRef.detectChanges();
          this.invokeTimeago();
        },
        error => {
        }
      );
  }

    prependMentions(postObj) {
    const base = this;
    if (this.mentionIds.length > 0) {
      if (this.mentionIds[0].id == 'All') {
        this.mentionIds = [...this.allUsers];
      }
      const mentionString = _.map(this.mentionIds, function(mention) {
        return `@${mention.name}`;
      });
      postObj.mention_message = `${mentionString}:`;
      if (this.pageType == 'teams') {
        postObj.mentionIds = _.map(this.mentionIds, 'userId');
      } else {
        postObj.mentionIds = _.map(this.mentionIds, 'id');
      }
      postObj.internal = true;
    }
  }

  updateAccessUsers() {
    if (this.channelType == 'teams') {
      this.updateObj.internal_users = _.map(this.teamMails, 'id');
    } else if (this.channelType !== 'orgs' && this.isQountOrgUser) {
      if (this.updateObj.internal) {
        this.updateObj.internal_users = _.map(this.internalMails, 'id');
      } else {
        this.updateObj.external_users = _.map(this.externalMails, 'id');
      }
    }
  }

  resetFields() {
    this.mentionIds = [];
    this.mentions = [];
    this.allUsers = [];
    setTimeout(() => {
      if (!(this.changeDetectionRef as ViewRef).destroyed) {
        this.changeDetectionRef.detectChanges();
      }
    });
  }

}
